import $ from 'jquery'
import { tsInitVue } from './js-utils'
import ExternalEventParticipantsGrid from '../js/vue-components/external-event-participants-grid.vue'
import ExternalParticipantsImportGrid from '../js/vue-components/external-participants-import-grid.vue'
import axios from 'axios'
import Rails from '@rails/ujs'

document.addEventListener('DOMContentLoaded', function () {
  const participantsGridEl = document.querySelector('[data-is="ExternalEventParticipantsGrid"]')
  if (participantsGridEl instanceof HTMLElement) {
    window.participantsGrid = tsInitVue(ExternalEventParticipantsGrid, participantsGridEl, {
      listUrl: participantsGridEl.dataset.listUrl
    })
  }

  if (document.querySelector('body.external-event-participants')) {
    const participantsImportGridEl = document.querySelector('[data-is="ExternalParticipantsImportGrid"]')
    if (participantsImportGridEl instanceof HTMLElement) {
      window.participantsImportGrid = tsInitVue(ExternalParticipantsImportGrid, participantsImportGridEl, {
        listUrl: participantsImportGridEl.dataset.listUrl
      })
    }
  }
  if (document.querySelector('body.external-events .external-events-form')) {
    const restoreMessageEl = document.querySelector('button[ref="restore-generic-message"]')
    if (restoreMessageEl instanceof HTMLElement) {
      restoreMessageEl.addEventListener('click', function (e) {
        e.preventDefault()
        if (confirm('Warning! This will replace content of your custom message with generic message. Are you sure?')) {
          const loadUrl = $(this).data('body-url')
          axios.post(loadUrl, {}, {
            headers: {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              'X-Requested-With': 'XMLHttpRequest',
              // eslint-disable-next-line @typescript-eslint/naming-convention
              'X-CSRF-Token': Rails.csrfToken()
            }
          })
            .then((response) => {
              $('input[name="external_event[email_subject]"]').val(response.data.subject)
              window.fWYSIWYG.get('external_event_email_body').setContent(response.data.body)
            })
            .catch((error) => {
              alert(`An error occured: ${error.message}`)
            })
        }
      })
    }
  }
})
